import useHostPartnerQuery from 'data/signup/use-host-partner-query';
import { PartnershipStatus } from 'data/signup/types';

export default function useWPCloudPartnershipStatus(): PartnershipStatus | null {
	const { isSuccess, data: hostPartner } = useHostPartnerQuery();

	if ( ! isSuccess ) {
		return null;
	}

	return hostPartner.host_partner?.partnerships?.wpcloud?.status ?? 'not_started';
}
